import usePaymentHook from "@/shared/hooks/usePaymentHook";
import { useTranslation } from "react-i18next";
import Icon, { IconsVariant } from "../Icon/Icon";

interface PosCartPaymentMethodProps {
  paymentId: number;
  isDisabled: boolean;
  onChange: () => void;
}

const PosCartPaymentMethod = ({
  paymentId,
  isDisabled,
  onChange,
}: PosCartPaymentMethodProps) => {
  const { t } = useTranslation();
  const { getPayment } = usePaymentHook();
  const payment = getPayment(paymentId);

  return (
    <button
      type="button"
      disabled={isDisabled}
      onClick={onChange}
      className="group mb-3 flex w-full cursor-pointer items-center gap-3 rounded-lg border border-primary/20 bg-primary/5 py-2.5 pr-3 pl-2.5 text-left transition-colors duration-200 hover:border-primary/50 hover:bg-primary/10 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:border-primary/20 disabled:hover:bg-primary/5"
    >
      <div className="flex size-14 shrink-0 items-center justify-center rounded-lg bg-white shadow-sm">
        <Icon
          variants={(payment?.icon ?? "creditcard") as IconsVariant}
          className="size-8 fill-primary"
        />
      </div>

      <div className="flex min-w-0 flex-1 flex-col">
        <span className="truncate text-[1.8rem] leading-tight font-bold text-text">
          {payment ? t(payment.translationKey) : t("paymentMethod")}
        </span>
        <span className="truncate text-small font-semibold text-primary">
          {t("changePaymentMethod")}
        </span>
      </div>

      <div className="flex size-10 shrink-0 items-center justify-center rounded-full bg-white text-primary ring-1 ring-primary/30 transition-colors duration-200 group-hover:bg-primary group-hover:text-white group-disabled:bg-white group-disabled:text-primary">
        <Icon variants="pencil" className="size-[1.2rem] fill-current" />
      </div>
    </button>
  );
};

export default PosCartPaymentMethod;
